module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av558-2307a021ee10b467022c745567ebe3fc.jpg";